import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Dropdown } from 'antd';

const FilterDropdown = ({
  className,
  children,
  placement = 'bottomCenter',
  filterButtonStyle,
  iconStyle
}) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  return (
    <StyledDropdown
      visible={isDropdownVisible}
      onVisibleChange={setIsDropdownVisible}
      overlay={<DropdownContent>{children}</DropdownContent>}
      placement={placement}
      className={className}
      trigger="click">
      <FilterButton
        active={isDropdownVisible}
        style={filterButtonStyle}
        onClick={() => setIsDropdownVisible(!isDropdownVisible)}>
        <i className="fa fa-filter" style={iconStyle} />
      </FilterButton>
    </StyledDropdown>
  );
};

const StyledDropdown = styled(Dropdown)``;

const DropdownContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  border: 1px solid #d0d7e3;
  width: 420px;
  background: #ffffff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%),
    0 9px 28px 8px rgb(0 0 0 / 5%);
`;

const FilterButton = styled.div`
  width: 32px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  i {
    color: ${({ active }) => (active ? '#91bced' : '#d9d9d9')};
  }

  &:hover {
    cursor: pointer;
  }
`;

FilterDropdown.propTypes = {
  className: PropTypes.string,
  placement: PropTypes.string
};

export default FilterDropdown;
